import React from "react";
import "./HeaderPage.css";
import "bootstrap/dist/css/bootstrap.min.css";

const HeaderPage = () => {
  return (
    <header className="zuppa_ajeet_head_wrapper fixed-top">
      <div className="container-fluid">
        <div className="row align-items-center justify-content-between">
          
          {/* Left Side - Logo */}
          <div className="col-auto">
            <img
              src="https://res.cloudinary.com/dmv2tjzo7/image/upload/v1735795527/zkvojccmuawxgh9eetf4.png"
              alt="Zuppa Logo"
              className="zuppa_ajeet_head_logo"
            />
          </div>

          {/* Right Side - Person Icon */}
          <div className="col-auto">
            <img
              src="https://cdn-icons-png.flaticon.com/512/16794/16794610.png"
              alt="Person Icon"
              className="zuppa_ajeet_head_icon"
            />
          </div>

        </div>
      </div>
    </header>
  );
};

export default HeaderPage;
